<template>
    <b-navbar class="container is-dark" :close-on-click="true" ref="menu">

        <template #brand>
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img src="@/assets/sitevitals-logo.png" width="112" height="28">
            </b-navbar-item>
        </template>

        <template #start>
            <template v-for="(link, i) in links">
                <template v-if="link.name">
                    <a
                        :key="`link_${i}`"
                        :class="$route.name == link.name ? 'navbar-item is-active' : 'navbar-item'"
                        @click="goTo(link,$event)"
                    >
                    {{ link.text }}
                    </a>
                </template>
                <template v-else-if="link.href">
                    <a
                        :href="link.href"
                        :key="`link_${i}`"
                        class="navbar-item">
                    {{ link.text }}
                    </a>
                </template>
            </template>
        </template>
        
        <template #end>
            <p class="navbar-item">{{ $store.getters.userHandle }}</p>
            <!-- <a class="navbar-item">
                <notification></notification>
            </a> -->
            <a class="navbar-item" :href="referrer" v-if="referrer!=='' && referrer!==null && !referrer.includes(appUrl)">Exit</a>
            <a class="navbar-item" @click.prevent="logout()" v-else>Logout</a>
        </template>

    </b-navbar>
</template>

<script>
// import notification from './Notification'
import _ from 'lodash/lodash';

export default {
    components:{
        // notification
    },
    data() {
        return {
            // notifications:[],
            page:1,
        }
    },
    computed: {
        links() {

            let links = [
                { name: "tickets", text: "Tickets" },
                { name: "guide", text: "Guides" },
            ];

            if(this.isRole('gatekeeper') || this.isRole('serviceperson')){
                links.push({
                    name: "releases",
                    text: "Releases"
                });
            }

            if(this.isRole('developer') || this.isRole('superadmin')){
                links.push({
                    name: "tasks",
                    text: "Tasks"
                });
            }

            if (this.isRole('superadmin') || this.isRole('gatekeeper')) {
                links.push({
                    name: "users",
                    text: "Users"
                });
            }

            if(this.isRole('serviceperson')){
                links.push({
                    name: "applications",
                    text: "Applications"
                });
            }

            if(this.isRole('superadmin') || this.hasPermission('can_view_status')) {
                links.push({
                    name:"status",
                    text:"Status"
                });
            }

            if(this.isRole('serviceperson') || this.isRole('superadmin')){
                links.push({
                    name: "meetings",
                    text: "Notes"
                });
            }

            return links;

        },
        referrer(){
            return document.referrer
        },
        appUrl(){
            return process.env.VUE_APP_URL
        }
    },
    methods: {
        logout() {
            this.$auth.logout({
                returnTo: `${window.location.origin}`
            });
        },
        goTo(link,e){
            // Can't work out why this is here but it throws errors
            // sometimes so added it into an if check for safety.
            if (_.get(e, 'path')) {
                e.path[5].children[1].click()
            }
            if(link.name!==this.$router.currentRoute.name)
            this.$router.push({
                name:link.name
            })
        }
    }
};
</script>
<style scoped>
    .navbar{
        position: sticky;
        top: 0;
    }
</style>